export const COMMON_STYLES = {
  height: "60px",
  display: "flex",
  alignItems: "center",
  p: 2,
  cursor: "pointer",
  fontWeight: 600,
};

export const CELL_COLORS = {
  error: {
    backgroundColor: "error.light",
    color: "error.main",
  },
  warning: {
    backgroundColor: "#e4ec81",
    color: "black",
  },
  selected: {
    backgroundColor: "gray",
    color: "gray.main",
  },
  deactivated: {
    backgroundColor: "#dddddd",
    color: "black",
  },
  none: {
    backgroundColor: "#cbf2ac",
    color: "black",
  },
  info: {
    backgroundColor: "#D0EFFD",
    color: "#000000",
  },
  mixed: {
    backgroundImage: "linear-gradient(to bottom right, #CBF2AC 50%, #D0EFFD 50%)",
    color: "black",
  },
};

export type CellColor = keyof typeof CELL_COLORS;
